import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[singleSpace]',
  standalone: true
})
export class SingleSpaceDirective {

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    let sanitizedValue = value.replace(/^\s+/, '');
    sanitizedValue = sanitizedValue.replace(/\s{2,}/g, ' ');
    this.el.nativeElement.value = sanitizedValue;
  }
}

